const markdownStyles = {
	root: { width: "100%" },
	view: {},
	codeBlock: {
		borderWidth: 1,
		borderColor: "#CCCCCC",
		backgroundColor: "#f5f5f5",
		padding: 10,
		borderRadius: 4
	},
	codeInline: {
		backgroundColor: "#f8f1f4",
		borderWidth: 0,
		borderColor: "transparent",
		color: "#d6336c",
		fontFamily: "Courier, monospace",
		fontWeight: "600",
		lineHeight: "1.2",
		padding: "1px 4px",
		borderRadius: 3
	},
	del: {
		backgroundColor: "#000000"
	},
	em: {
		fontStyle: "italic"
	},
	headingContainer: {
		flexDirection: "row"
	},
	heading: {
		marginBottom: 10
	},
	heading1: {
		fontSize: 32
	},
	heading2: {
		fontSize: 24
	},
	heading3: {
		fontSize: 18
	},
	heading4: {
		fontSize: 16
	},
	heading5: {
		fontSize: 13
	},
	heading6: {
		fontSize: 11
	},
	hr: {
		backgroundColor: "lightgray",
		height: 2,
		marginTop: 10,
		marginBottom: 10
	},
	blockquote: {
		alignSelf: "stretch",
		backgroundColor: "#f6f8fb",
		borderLeftColor: "#cbd5e1",
		borderLeftWidth: 6,
		borderLeftStyle: "solid",
		marginTop: 10,
		marginRight: 0,
		marginBottom: 12,
		marginLeft: 0,
		paddingTop: 10,
		paddingRight: 12,
		paddingBottom: 10,
		paddingLeft: 14
	},
	inlineCode: {
		backgroundColor: "#f8f1f4",
		borderColor: "transparent",
		borderRadius: 3,
		borderWidth: 0,
		color: "#d6336c",
		fontFamily: "Courier, monospace",
		fontWeight: "600",
		lineHeight: "1.2",
		padding: "1px 4px"
	},
	list: {
		width: "100%"
	},
	listItem: {
		flex: 1,
		flexWrap: "wrap",
		marginBottom: 5
	},
	listUnordered: {
		marginTop: 5
	},
	listUnorderedItem: {
		flexDirection: "row",
		justifyContent: "flex-start",
		flex: 1,
		flexGrow: 0
	},
	listUnorderedItemIcon: {
		fontWeight: "bold",
		marginLeft: 0,
		marginRight: 5,
		lineHeight: 36
	},
	listUnorderedItemText: {
		fontSize: 20,
		lineHeight: 20
	},
	listOrdered: {
		marginTop: 5
	},
	listOrderedItem: {
		flexDirection: "row",
		flex: 1,
		flexGrow: 0
	},
	listOrderedItemIcon: {
		fontWeight: "bold",
		marginLeft: 0,
		marginRight: 5,
		lineHeight: 36
	},
	listOrderedItemText: {
		fontWeight: "bold",
		lineHeight: 20
	},
	paragraph: {
		marginTop: 5,
		marginBottom: 5,
		flexWrap: "wrap",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "flex-start"
	},
	hardbreak: {
		width: "100%",
		height: 1
	},
	strong: {
		fontWeight: "bold"
	},
	table: {
		borderWidth: 1,
		borderColor: "#000000",
		borderRadius: 3
	},
	tableHeader: {},
	tableHeaderCell: {
		flex: 1,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: "black",
		backgroundColor: "#eeeeee"
	},
	tableRow: {
		borderBottomWidth: 1,
		borderColor: "#000000",
		flexDirection: "row"
	},
	tableRowCell: {
		flex: 1,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: "black"
	},
	text: {},
	strikethrough: {
		textDecorationLine: "line-through"
	},
	link: {
		textDecorationLine: "underline"
	},
	blocklink: {
		flex: 1
	},
	u: {
		borderColor: "#000000",
		borderBottomWidth: 1
	},
	image: {
		resizeMode: "contain"
	}
};

export default markdownStyles;
